import { render } from "./RepresentantesView.vue?vue&type=template&id=da8d4d9e"
import script from "./RepresentantesView.vue?vue&type=script&lang=js"
export * from "./RepresentantesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__